// extracted by mini-css-extract-plugin
export default {"containerProducts":"listProducts_containerProducts__R2Jp+","h2Products":"listProducts_h2Products__sLR1U","h5Products":"listProducts_h5Products__KTwiC"};